import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { Collapse } from "@mui/material";
import clsx from "clsx";
import * as React from "react";
import "swiper/css";

type Props = {
  buttonText: string;
  content: string | React.ReactElement | React.ReactElement[];
  initOpen?: boolean;
};

export default function ToggleButton({
  buttonText,
  content,
  initOpen = false,
}: Props): React.ReactElement {
  const [isOpen, setOpen] = React.useState(initOpen);

  const switchOpen = () => {
    setOpen((s) => !s);
  };

  return (
    <div className="not-prose my-4">
      <button
        className="bg-gray-200 text-md font-medium w-full text-left py-2 px-4 rounded-sm flex items-center"
        onClick={switchOpen}
      >
        {buttonText}
        <KeyboardArrowDownRoundedIcon
          className={clsx("ml-auto transition-transform", {
            ["rotate-180"]: !isOpen,
          })}
        />
      </button>
      <Collapse in={isOpen}>
        <div className="py-2 px-4 text-md">{content}</div>
      </Collapse>
    </div>
  );
}
